import { useContext } from "react"
import RegisterableContext from "components/admin/registerable/context"
import { Pane } from "components/ui"

const Errors = () => {
  const { errors } = useContext(RegisterableContext)

  return !errors || errors.length === 0 ? null : (
    <Pane marginBottom={2}>
      <Pane.Body axis="vertical" gap={2} className="error-alert">
        {errors.map((error, i) => (
          <div key={i}>{error.detail}</div>
        ))}
      </Pane.Body>
    </Pane>
  )
}

export default Errors
